import { useContext, useEffect, useRef, useState } from 'react'
import logo from '../../../assets/logo.svg'
import HamburgerMenu from '../hamburger-menu/hamburgerMenu'
import './header.scss'
import propositoIcon from '../../../assets/objetivo.svg'
import diagnosticoIcon from '../../../assets/grafico-histograma.svg'
import miRutaIcon from '../../../assets/ruta.svg'
import servicesIcon from '../../../assets/archivar-factura.svg'
import DirectAccessItem from '../direct-access-item/directAccessItem'
import emailIcon from '../../../assets/email-blue.svg'
import proximamenteIcon from "../../../assets/proximamente.svg"
import rompecabezasGris from "../../../assets/pieza-rompecabezas-gris.png"
import { login, logout } from '../../../utils/gigya'
import authContext from '../../../contexts/authContext'
import UserDisplay from '../user-display/userDisplay'
import { normalizeText } from '../../../utils/stringManipulation'
import BlurBackground from '../../atoms/blur-background/blurBackground'
import { Badge } from '../badge'
import trophyIcon from '../../../assets/trophy-icon.svg'
import UserPointsContext from '../../organisms/layout/contexts/user-points.context'
import { useLocation } from 'react-router-dom'

const HamburgerMenuOpen = ({ setOpen }: { setOpen: any }) => {

	const baseURL = process.env.REACT_APP_REDIRECT_URL;

	const navLinks = [
		{
			icon: propositoIcon,
			title: "Propósito",
			disabled: false,
			redirectURL: "diagnostico-financiero/#/propositos/"
		},
		{
			icon: diagnosticoIcon,
			title: "Diagnóstico",
			disabled: false,
			redirectURL: "diagnostico-financiero/#/formulario-salud-educacion-financiera/"
		},
		{
			icon: miRutaIcon,
			title: "Mi ruta",
			disabled: false,
			redirectURL: "ruta/"
		},
		{
			icon: rompecabezasGris,
			title: "¡Juguemos!",
			disable: false,
			redirectURL: "perfil/"
		},
		{
			icon: servicesIcon,
			title: "Servicios",
			disabled: false,
			redirectURL: "servicios/"
		},
	]

	const handleClick = () => {
		setOpen(false);
	}
	
	return (
		<div className="hamburger-menu">
			<div className="hamburger-menu__options">
				{
					navLinks.map((item) => {
						let isActive = window.location.href.includes(item.redirectURL);
						return (
							!item.disabled ?
								<a
									href={baseURL + item.redirectURL}
									rel="noreferer"
									className={`hamburger-menu__options__item ${isActive ? 'hamburger-menu__options__item--active' : ''}`}
									key={item.title}
									onClick={handleClick}
								>
									<img src={item.icon} alt={item.title}></img>
									<h2>{item.title}</h2>
								</a>
								:
								<div className={`hamburger-menu__options__item ${item.disabled ? '--disabled' : ''}`} key={item.title}>
									<img src={item.icon} alt={item.title}></img>
									<h2>{item.title}</h2>
									{item.disabled ? <img className="hamburger-menu__options__item__proximamente" src={proximamenteIcon} alt="Próximamente" /> : <></>}
								</div>
						)
					})
				}
			</div>
			<span className="divider"></span>
			<div className="hamburger-menu__direct-access">
				<h3>Accesos directos</h3>
				<p>Algunas opciones que harán más fácil tu proceso</p>
				<div className="hamburger-menu__direct-access__items">
					<DirectAccessItem icon={emailIcon} title='Contáctanos' description='¿Necesitas ayuda con tu diagnóstico?' redirect='https://forms.office.com/r/R1QEmkEEwb' />
				</div>
			</div>
		</div>
	);
};

const Header = () => {

	const location = useLocation();
	const [open, setOpen] = useState(false);
	const auth = useContext(authContext);
	const {points, getPoints} = useContext(UserPointsContext);
	const ref = useRef<any>(null);

	useEffect(() => {
		function handleClickOutside(event: any) {
			if (ref.current && !ref.current?.contains(event.target)) {
				setOpen(false);
			}
		}
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	useEffect(() => {
		getPoints();
	});
	
	return (
		<>
			<header className="s-header" ref={ref}>
				<div className="s-header__menu">
					<HamburgerMenu setOpen={setOpen} open={open} />
					<a className="s-header__menu__logo" href="/mentoria-financiera/" rel='noreferer'>
						<img src={logo} alt="Logo Mentoría Financiera" />
					</a>
				</div>
				<div className='s-header__user'>
					<UserDisplay isLoggedIn={auth.isLoggedIn} userImage={auth.gigyaAccount?.profile.photoURL || ''} userName={normalizeText(auth.gigyaAccount?.profile.firstName + ' ' + auth.gigyaAccount?.profile.lastName as string) || ''} onCloseSession={() => logout()} onStartSession={() => login()} />
					{auth.isLoggedIn && (
						<div className="s-header__user-desktop">
							<Badge>
								<img className='m-badge__icon' src={trophyIcon} />
								<span>{ points ? points : '🤓' }</span>
							</Badge>
						</div>
					)}
				</div>
				{open &&
					<>
						<HamburgerMenuOpen setOpen={setOpen} />
						<BlurBackground />
					</>}
			</header>
		</>
	)
}

export default Header